import React from "react";
import { Select } from "@material-ui/core";

import cn from './styles.module.scss';
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

export const ECHECK_PAYMENT_CONFIG = {
  apasi_bank_account_type: { key: 'apasi_bank_account_type' },
  apasi_account_name: { key: 'apasi_account_name' },
  apasi_bank_account_number: { key: 'apasi_bank_account_number' },
  apasi_bank_name: { key: 'apasi_bank_name' },
  apasi_bank_routing_number: { key: 'apasi_bank_routing_number' },
};

export const ECheckPaymentForm = () => {
  return (
    <div className={cn.cardPaymentForm}>
      <span className={cn.required}>Account Type:</span>
      <Select
        name={ECHECK_PAYMENT_CONFIG.apasi_bank_account_type.key}
        required
        defaultValue="savings"
        variant="outlined"
      >
        <MenuItem value="savings">Savings</MenuItem>
        <MenuItem value="checking">Checking</MenuItem>
        <MenuItem value="businessChecking">Business Checking</MenuItem>
      </Select>
      <span className={cn.required}>Name on Account:</span>
      <TextField
        name={ECHECK_PAYMENT_CONFIG.apasi_account_name.key}
        required
        variant="outlined"
        inputProps={{
          maxLength: 22
        }}
      />
      <span className={cn.required}>Account Number:</span>
      <TextField name={ECHECK_PAYMENT_CONFIG.apasi_bank_account_number.key} required variant="outlined" />
      <span className={cn.required}>Bank Name:</span>
      <TextField name={ECHECK_PAYMENT_CONFIG.apasi_bank_name.key} required variant="outlined" />
      <span className={cn.required}>Routing Number:</span>
      <TextField name={ECHECK_PAYMENT_CONFIG.apasi_bank_routing_number.key} required variant="outlined" />
    </div>
  )
};
